import "angular";
import SamlTokenFactory from "./SamlTokenFactory";
import SamlTokenService from "./SamlTokenService";
import ProcessSsoDirective from "./ProcessSsoDirective";
import SamlDisclaimerDirective from "./SamlDisclaimerDirective";
import CommonBondDirective from "./CommonBondDirective";

const SamlTokenModule = angular
    .module("SamlTokenModule", [])
    .service("samlTokenService", SamlTokenService)
    .factory("samlTokenFactory", SamlTokenFactory)
    .directive("processSsoDirective", ProcessSsoDirective)
    .directive("samlDisclaimer", SamlDisclaimerDirective)
    .directive("commonBond", CommonBondDirective);

export default SamlTokenModule;
